// @ts-nocheck

import React, { useState } from 'react';
import { useCallback } from 'react';
import styled, { keyframes, css } from 'styled-components';

import { Target } from '../../client';
import { SpineAnimationIds } from '../../types/animations';
import { SpineAnimationId } from '../../types/animations';
import ImageWithLoadCallback from '../ImageWithLoadCallback';
import SpinePlayer from '../SpinePlayer';
import WinModalAnimationFitText from '../WinModalAnimationFitText';

const animationText = keyframes`
0% {
  opacity: 0;
  transform: scale(0);
}
100% {
  opacity: 1;
  transform: scale(1);
}
`;

const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  text-align: center;
  margin: 0 auto;
  background-color: #000;
`;

const backgroundCss = css`
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 0;

  canvas {
    left: 0;
  }
`;

const BackgroundImage = styled(ImageWithLoadCallback)`
  ${backgroundCss}
`;

const BackgroundSpine = styled(SpinePlayer)`
  ${backgroundCss}
`;

const BannerSpine = styled(SpinePlayer)`
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 1;

  canvas {
    left: 0;
  }
`;

const Text = styled(WinModalAnimationFitText)`
  position: absolute;
  top: 83%;
  left: 0;
  right: 0;
  max-height: ${Target.__MOBILE__ ? '2em' : '3em'};
  margin: 0 auto;
  z-index: 1;
  font-family: BettingPoliticaExtraBold, sans-serif;
  color: ${({ theme }) => theme.common.colors.secondary};
  text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.5);
  animation: ${animationText} 1s 500ms cubic-bezier(0.75, -0.5, 0, 1.75) both;
  user-select: none;
`;

const Badge = styled(ImageWithLoadCallback)`
  position: absolute;
  ${({ $top, $left, $width }) => css`
    top: ${$top};
    left: ${$left};
    width: ${$width};
  `}

  height: auto;
  animation: ${animationText} 500ms 1s cubic-bezier(0.75, -0.5, 0, 1.75) both;
`;

type WinModalAnimationProps = {
  width: number;
  text: string;
  bannerAnimationId: SpineAnimationId;
  backgroundAnimationId: SpineAnimationId;
  badge: unknown;
  fallback?: string;
  className?: string;
};

const WinModalAnimation = ({
  className = '',
  bannerAnimationId,
  backgroundAnimationId,
  badge,
  text,
  fallback,
}: WinModalAnimationProps) => {
  const [showText, setShowText] = useState(false);

  const onEndBannerAnimation = useCallback(() => {
    setShowText(true);
  }, []);

  return (
    <Wrap className={className}>
      {badge ? <Badge src={badge.image} $width={badge.width} $left={badge.left} $top={badge.top} /> : null}
      {backgroundAnimationId && !fallback ? <BackgroundSpine animationId={backgroundAnimationId} /> : null}
      {fallback && !backgroundAnimationId ? <BackgroundImage src={fallback} /> : null}
      {bannerAnimationId ? (
        <BannerSpine animationId={bannerAnimationId} scale={0.9} onEndAnimation={onEndBannerAnimation} />
      ) : null}

      {bannerAnimationId !== SpineAnimationIds.BS_CANCEL && showText ? (
        <Text key={`svg-text-${bannerAnimationId}`} text={text} />
      ) : null}
    </Wrap>
  );
};

export default WinModalAnimation;
